import { Component, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { DarkModeService } from './services/dark-mode.service';
import { isPlatformBrowser } from '@angular/common';
import { DevToolsBlockerService } from './services/devtools-blocker.service';
import { ThemeService } from './services/theme.service';
import { SequenceService } from './services/sequence.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  isOnline: boolean | undefined;
  hideHeaderFooter: boolean = false;
  title = 'Odda Web App';

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {
    this.sequence._0xO4(event);
  }

  @HostListener('document:touchstart', ['$event'])
  onTouch(event: TouchEvent) {
    this.sequence._0xO4(event);
  }

  constructor(
    private darkModeService: DarkModeService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private devToolsBlocker: DevToolsBlockerService,
    private themeService: ThemeService,
    private sequence: SequenceService,
  ) {}

  async ngOnInit() {
    await this.themeService.loadConfig();
    this.devToolsBlocker.enableBlock();
    this.colorTheme();
  }

  colorTheme() {
    this.darkModeService.darkMode$.subscribe((isDarkMode) => {
      if (isPlatformBrowser(this.platformId)) {
        document.body.classList.toggle('dark-mode', isDarkMode);
        this.applyTheme(isDarkMode);
      }
    });
  }

  applyTheme(isDarkMode: boolean) {
    if (isDarkMode) {
      this.themeService.applyTheme('darkMode');
    } else {
      this.themeService.applyTheme('lightMode');
    }
  }

  ngOnDestroy(): void {
    this.devToolsBlocker.disableBlock();
  }
}
